import { MergeTagApiModel } from '../../../api/distributions/model/merge-tag.api.model';

export class MergeTagModel {
    key: string;
    label?: string;
    fallback?: MergeTagApiModel;

    constructor(apiModel?: MergeTagApiModel) {
        if (apiModel) {
            this.key = apiModel.key;
            this.fallback = apiModel.fallback;
            this.label = `Discover.personalizationTag.${this.key}`;
        } else {
            this.key = null;
            this.label = null;
            this.fallback = null;
        }
    }

    toApiModel(): MergeTagApiModel {
        return {
            key: this.key,
            fallback: {
                key: this.fallback.key,
            }
        };
    }
};

